import createBookingServiceOperation from 'owa-service/lib/operation/createBookingServiceOperation';
import CreateBookingServiceJsonResponse from 'owa-service/lib/contract/CreateBookingServiceJsonResponse';
import CreateBookingServiceResponseMessage from 'owa-service/lib/contract/CreateBookingServiceResponseMessage';
import CreateBookingServiceJsonRequest from 'owa-service/lib/contract/CreateBookingServiceJsonRequest';
import BookingService from 'owa-service/lib/contract/BookingService';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

const perDefinedService: BookingService = {
    PreBuffer: 0,
    PostBuffer: 0,
    StaffPersonIds: [],
};

/**
 * Service call to create a booking service.
 */
export default async function createBookingService(
    service: BookingService
): Promise<CreateBookingServiceResponseMessage> {
    let request: CreateBookingServiceJsonRequest = {
        Header: getJsonRequestHeader(),
        Body: {
            Service: createBookingServiceBody(service),
        },
    };

    let response: CreateBookingServiceJsonResponse = await createBookingServiceOperation(request);

    let result: CreateBookingServiceResponseMessage = null;
    if (response && response.Body && response.Body.ResponseClass === 'Success') {
        result = response.Body;
    }

    return result;
}

function createBookingServiceBody(service: BookingService): BookingService {
    validateService(service);
    return { ...perDefinedService, ...service };
}

function validateService(service: BookingService) {
    if (!service.DisplayName) {
        throw new Error('Service displayName cannot be null.');
    }

    if (!service.Description) {
        throw new Error('Service description cannot be null.');
    }

    if (!service.InternalNotes) {
        throw new Error('Service internal notes cannot be null.');
    }

    if (service.DefaultDurationMinutes <= 0) {
        throw new Error('Service duration should be valid.');
    }
}
